import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import InsightPanel from '../Insight/InsightPanel';
import { useInsightStore } from '../../stores/useInsightStore';

const SIDEBAR_WIDTH = 240;
const INSIGHT_WIDTH = 320;
const TOPBAR_HEIGHT = 56;

/**
 * 桌面三栏布局组件。
 * - 左侧 Sidebar（240px，可折叠）
 * - 中间主内容区（flex:1）
 * - 右侧 InsightPanel（320px，默认隐藏）
 */
const MainLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const { isOpen: insightOpen, closePanel } = useInsightStore();

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <Box sx={{ display: 'flex', height: '100vh', width: '100vw', overflow: 'hidden' }}>
      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        width={SIDEBAR_WIDTH}
      />

      {/* 主内容区域 */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minWidth: 0,
          transition: 'margin-left 0.3s ease',
          marginLeft: sidebarOpen && !isMobile ? `${SIDEBAR_WIDTH}px` : 0,
        }}
      >
        <TopBar
          height={TOPBAR_HEIGHT}
          sidebarOpen={sidebarOpen}
          onToggleSidebar={toggleSidebar}
        />

        <Box
          sx={{
            display: 'flex',
            flex: 1,
            overflow: 'hidden',
          }}
        >
          {/* 路由页面内容 */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              overflow: 'auto',
              bgcolor: 'background.default',
            }}
          >
            <Outlet />
          </Box>

          {/* Insight Panel */}
          <Box
            sx={{
              width: insightOpen ? INSIGHT_WIDTH : 0,
              flexShrink: 0,
              overflow: 'hidden',
              transition: 'width 0.3s ease',
              bgcolor: '#FAF7F2',
              borderLeft: insightOpen ? '1px solid #E8E2D9' : 'none',
            }}
          >
            {insightOpen && (
              <InsightPanel onClose={closePanel} />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
